<template>
    <div class="mutual">
      <div
        :style="{height: `calc(100vh - ${mutualH})`}"
        class="mutual-content scroll-my"
        refresher-enabled
        @refresherrefresh="refresherrefresh"
        scroll-with-animation
        :scroll-top="scrollTop"
        :refresher-triggered="refresher"
        ref="scroll"
      >
        <div class="hint">
          <div><img src="http://images.snsports.cn/bsn_gth_icon.png" /></div>
          <p>欢迎 {{name}}（用户名）收看&nbsp;&nbsp;<span style="font-weight: 700;margin: 0 4px;">{{ game.homeTeam.name }}队</span>&nbsp;&nbsp;VS&nbsp;&nbsp;<span style="font-weight: 700;margin: 0 4px;">{{ game.awayTeam.name }}队</span>的精彩比赛。斑马邦直播间内严禁出现违法违规、低俗色情、吸烟酗酒、人身伤害等内容。如直播及互动过程中涉及诱导支付、线下交易，请谨慎判断，以防人生财产损失，请大家注意财产安全，谨防网络诈骗。</p>
        </div>
        <div v-for="(item,index) in commentList" :key="index">
          <div class="item">
            <div>{{ item.author.nickName }}</div>
            {{ item.contentTxt }}
          </div>
        </div>
      </div>
      <div class="footer" ref="footer">
          <div style="overflow-x: auto;" class="scroll-my">
            <div class="box">
              <div v-for="item in footerList" :key="item" @click="AddComment(item)">{{ item }}</div>
            </div>
          </div>
        <div class="info flex-conter">
          <img :src="infoImg" class="tx" />
          <input type="text" v-model="value" @click="isLogin" confirm-type="send" @confirm="AddComment(value)" placeholder="我来说几句...">
          <div  class="fx" @click="AddComment(value)">发布</div>
        </div>
      </div>
    </div>
</template>

<script>
import { GetCommentList, AddComment } from '@/api/match'
export default {
  props: {
    game: {
      type: Object,
      default: () => {}
    },
    gameId: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    infoImg: {
      type: String,
      default: ''
    },
    passport: {
      type: String,
      default: ''
    },
  },
  computed: {
    scrollHeight() {
      return this.tall - this.height + 40
    },
    mutualH(){
      return this.footerH + this.height + 'px'
    }
  },
  data() {
    return {
      footerList: ['好球', '漂亮', '666', '加油！！！', '冲冲冲！', '就压着打', 'siu siu siu', 'Gooooooooal！！！', '唰唰唰'],
      commentList: [],
      commentListTop: [],
      name: '',
      tall: 0,
      value: '',
      scrollTop: 0,
      len: 0,
      pageNum: 1,
      pageSize: 5,
      refresher: false,
      anchorId: '',
      timer: null,
      footerH:0
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.GetCommentList(1)
    }, 5000)
    this.footerH = this.$refs.footer.offsetHeight
    setTimeout(()=> {
      const scrollHeight = this.$refs.scroll &&this.$refs.scroll.scrollHeight
      let num = 0
      let timer = setInterval(() => {
        if(num >= 100){
          clearInterval(timer)
        } else {
          num += 1
          this.$refs.scroll && (this.$refs.scroll.scrollTop += (scrollHeight || 1)/100)
        }
      },10)
    },2000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    mutualLoad(){
      console.log(123);
    },
    GetCommentList(num) {
      const params = {
        objId: this.gameId,
        objType: 'game',
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        isDown: num,
        anchorId: this.anchorId
      }
      GetCommentList(params).then(res => {
        const { data } = res
        const list = data.commentList.reverse()
        if (num === 0) {
          this.commentList.unshift(...list)
          this.scrollTop = 0
        } else {
          this.isDown = 0
          this.commentList.push(...list)
          const num = (this.commentList.length + 1) * 46 + 142
          this.scrollTop = num
        }
        if (this.commentList && this.commentList[this.commentList.length - 1].id) {
          this.anchorId = this.commentList[this.commentList.length - 1].id
        }
        this.refresher = false
      })
    },
    AddComment(item) {
      console.dir(this.$refs.scroll);
      this.isLogin()
      const params = {
        objType: 'game',
        objId: this.gameId,
        contentTxt: item,
        passport:this.passport
      }
      AddComment(params).then(() => {
        this.value = ''
        this.GetCommentList(1)
        setTimeout(()=>{
          this.$refs.scroll.scrollTop = this.$refs.scroll.scrollHeight
        },100)
      })
    },
    isLogin(){
      this.$emit('isLogin')
    },
    refresherrefresh() {
      this.refresher = true
      this.anchorId = this.commentList[0].id
      setTimeout(() => {
        this.GetCommentList(0)
      }, 500)
    }
  }
}
</script>

<style scoped lang="scss">
.mutual{
  border-top: 1px solid #EEEEEE;
  padding-bottom: 77.5px;
  .mutual-content{
    background-color: #Fff;
    padding: 12px 16px;
    box-sizing: border-box;
    overflow-y: auto;
    .hint{
      p{
        margin: 0 !important;
      }
      width: 319px;
      background: rgba(226,232,253,0.4);
      border-radius: 6px;
      padding: 8px 12px;
      display: flex;
      font-size: 13px;
      color: #5B7AFF;
      img{
        width: 16px;
        height: 16px;
        margin-right: 13px;
      }
    }
    .item{
      display: inline-block;
      padding: 8px 12px;
      background: #FAFAFB;
      border-radius: 6px;
      margin-top: 12px;
      font-size: 13px;
      color: #191919;
      max-width: 343px;
      height: auto;
      div{
        float: left;
        margin-right: 8px;
        color: #8C8C8C;
      }
    }
  }
  .footer{
    position: fixed;
    bottom: 0px;
    width: 100vw;
    background-color: #fff;
    padding: 5px 14px 8px 13px;
    border-top: 1px solid #eee;
    height: 85px;
    box-sizing: border-box;
    z-index: 9;
    .box{
      display: flex;
      width: 245%;
      padding-bottom: 5px;
      div{
        height: 30px;
        line-height: 30px;
        text-align: center;
        padding: 0 12px;
        background: rgba(226,232,253,0.4);
        border-radius: 16.5px;
        color: #5B7AFF;
        font-size: 13px;
        margin-left: 12px;
      }
    }
  }
  .info{
    padding-bottom: 17px;
    width: 100%;
    background: #fff;
    .tx{
      width: 27px;
      height: 27px;
      border-radius: 50%;
      margin-right: 8px;
    }
    input{
      flex: 1;
      background: #FAFAFB;
      padding: 8px 12px;
      border-radius: 18px;
      font-size: 14px;
    }
    .fx{
      width: 52px;
      height: 28px;
      background: linear-gradient(328deg, #FF3726 0%, #F98051 100%);
      border-radius: 14px;
      text-align: center;
      line-height: 28px;
      margin-left: 10px;
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
    }
  }
}

.flex-conter{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.overflow-text{
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.scroll-my{
  &::-webkit-scrollbar{
    display: none;
  }
}
</style>
